<!-- 组件说明 -->
<template>
  <div>
    跳转中。。。
  </div>
</template>

<script>
import Vue from 'vue';

import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getLoginInfo } from '@/api/login';
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    getLoginData() {
      getLoginInfo().then(res => {
        if (res.success) {
          const result = res.result;
          const userInfo = res.userInfo;
          Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000);
          Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000);
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000);
          Vue.ls.set(
            UI_CACHE_DB_DICT_DATA,
            result.sysAllDictItems,
            7 * 24 * 60 * 60 * 1000
          );
          commit('SET_TOKEN', result.token);
          commit('SET_INFO', userInfo);
          commit('SET_NAME', {
            username: userInfo.username,
            realname: userInfo.realname,
            welcome: welcome()
          });
          commit('SET_AVATAR', userInfo.avatar);
        }
        console.log('res*********', res);
      });
    }
  },
  mounted() {
    // this.getLoginData();
    if (this.$route.query.token) {
      Vue.ls.set(
        ACCESS_TOKEN,
        this.$route.query.token,
        7 * 24 * 60 * 60 * 1000
      );
    }
    setTimeout(() => {
      this.$router.replace({
        path: '/dashboard/analysis'
      });
    }, 1000);
  }
};
</script>

<style scoped></style>
